define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/action/Controller",
	"csi/xml"
], function(declare,lang,when,Controller,xml) {

	return declare(Controller, {
		process: function() {
			// summary: apply the current sorting to the relationship
			var	qr = this.widget.getQueryResult();

			when(qr.store.getFullRequest(),
				lang.hitch(this, function(urls) {
					this.m_writer.changeNode(qr.url).changeAttribute(qr.level.childLevel.parentAttribute, xml.ATTR_REFVECTOR, urls);
					this.publish();
				}),
				lang.hitch(this, this._onPublishError)
			);
		},

		postProcessSuccess: function() {
			// summary: reset sorting in view
			this.widget.set("sortSettings", []);
			this.widget.showSortHeaders();
			this.widget.redrawNewData();
		}
	});
});